/**
 * GST invoices apply to physical/item cart lines only — not subscriptions.
 */
export function cartOrderQualifiesForInvoice(order) {
  if (!order) return false;

  const items = order.items || [];
  const packages = order.packages || [];
  const hasItems = items.length > 0;
  const hasPackages =
    packages.length > 0 ||
    order.isPackagePurchase === true ||
    order.orderType === "package_purchase";

  if (hasPackages && !hasItems) {
    return false;
  }

  return hasItems;
}
